export default __webpack_public_path__ + "img/fcea0bcd31a3bebc8a3e7a3cde2e849b.svg";